import React from 'react'
import Image from 'next/image'
import styled, { css } from 'styled-components'
import { lighter } from '../helpers/color'
import { breakpoint } from '../layout/styles'
import { Container } from '../styles/Container'
import { Grid, Cell } from '../styles/Grid'

const IconSections = ({ data }: any) =>
  <Wrapper
    hasTitle={data.title !== null && data.title !== undefined && data.title !== ''}
    background={lighter(data.background_color?.[0]?.background)}
    margin={data?.margin}>
    {data.title && <SectionTitle>{data.title}</SectionTitle>}
    <Grid>
      {data.items.map((item: any) =>
        <Section key={item._metadata.uid}>
          {item.link?.href && (
            <a href={item.link.href} target="_blank">
              <Image 
                src={item.icon?.url} 
                alt={item.title || "Icon"}
                width={data.icon_size || 92}
                height={data.icon_size || 92}
                objectFit="cover" 
              />
            </a>
          )}
          {!item.link?.href && (
            <Image 
              src={item.icon?.url} 
              alt={item.title || "Icon"}
              width={data.icon_size || 92}
              height={data.icon_size || 92}
              objectFit="cover" 
            />
          )}
          {item.title && <h4>{item.title}</h4>}
          {item.description && <ItemDescription>{item.description}</ItemDescription>}
        </Section>)}
    </Grid>
  </Wrapper>

export default IconSections

const Wrapper = styled(Container)`
  color: var(--text);
  margin: ${props => props.margin !== null && props.margin === 'no-margin' ? '0' : '36px'} 20px 0;
  background: ${props => props.background || 'none'};
  padding: 20px;

  @media screen and ${breakpoint.desktop} {
    margin-left: auto;
    margin-right: auto;
    padding: 0;
    background: none;
  }
`

export const Section = styled(Cell)`
  text-align: center; 
  margin: 1rem 0;
  @media ${breakpoint.desktop} {
    width: 33.3333%;
    margin: 0;
  }
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
  h4 {
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    text-align: center;
  }
  p {
    font-size: 14px;
    @media ${breakpoint.desktop} {
      font-size: 16px;
    }
  }
`
const SectionTitle = styled.h3`
  margin: 16px 0;
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  @media ${breakpoint.desktop} {
    margin-bottom: 2rem;
    font-size: 36px;
  }
`

const ItemDescription = styled.p<any>`
  @media ${breakpoint.desktop} {
    margin: auto;
    max-width: 280px;
  }
`
